import { useEffect } from "react";
import "@/components/escape21/escape21.css";
import Hero from "@/components/escape21/Hero";
import SocialProof from "@/components/escape21/SocialProof";
import WhatIs from "@/components/escape21/WhatIs";
import Included from "@/components/escape21/Included";
import HabitsScroll from "@/components/escape21/HabitsScroll";
import HowItWorks from "@/components/escape21/HowItWorks";
import AppShowcase from "@/components/escape21/AppShowcase";
import AppFeatures from "@/components/escape21/AppFeatures";
import Prizes from "@/components/escape21/Prizes";
import FounderAccess from "@/components/escape21/FounderAccess";
import ForWhom from "@/components/escape21/ForWhom";
import Pricing from "@/components/escape21/Pricing";
import Faq from "@/components/escape21/Faq";
import FinalCta from "@/components/escape21/FinalCta";
import StickyCta from "@/components/escape21/StickyCta";

const Escape21 = () => {
  useEffect(() => {
    document.title = "escape21. 21 dias. R$1 por dia.";
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans text-black antialiased">
      {/* grain sutil por cima de tudo */}
      <div className="e21-grain" aria-hidden="true" />

      <Hero />
      <SocialProof />
      <WhatIs />
      <Included />
      <HabitsScroll />
      <HowItWorks />
      <AppShowcase />
      <AppFeatures />
      <Prizes />
      <FounderAccess />
      <ForWhom />
      <Pricing />
      <Faq />
      <FinalCta />
      <StickyCta />
    </div>
  );
};

export default Escape21;
